export default __webpack_public_path__ + "static/media/parental-control-app-circle.3a3bdf59.webp";